import React from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'

function CategorySelector(props) {
  const { categoryId, categories } = props

  const updateValue = (option) => {
    props.onChange(option ? option.id : null)
  }

  const optionRenderer = (option) => {
    const style = {padding: '4px', borderRadius: '8px', ...colors(option)}
    return <div style={style}>{option.name}</div>
  }

  const valueRenderer = (option) => {
    return <span style={colors(option)}>{option.name}</span>
  }

  const colors = (option) => {
    const bgColor = option ? option.backgroundColor : '#eee'
    const color = option ? option.textColor : '#000'
    return {backgroundColor: bgColor, color: color}
  }

  if (!categories.length) return null

  const selectedOption = categories.find(c => c.id == categoryId)

  return (
    <div className='reservation-category-selector' style={colors(selectedOption)}>
      <Select
        arrowRenderer={() => null}
        clearable={!!categoryId}
        onChange={updateValue}
        options={categories}
        optionRenderer={optionRenderer}
        placeholder='Add a Category'
        searchable={false}
        value={selectedOption}
        valueRenderer={valueRenderer}
      />
    </div>
  )
}

CategorySelector.propTypes = {
  categoryId: PropTypes.number,
  categories: PropTypes.array,
}

export default CategorySelector
